import type { SVGProps } from 'react';

const StreamSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      d="M19 9C20.1046 9 21 9.89543 21 11V13.333L24.4453 11.0361C25.1098 10.5933 25.9997 11.0697 26 11.8682V20.1318C25.9997 20.9303 25.1098 21.4067 24.4453 20.9639L21 18.666V21C21 22.1046 20.1046 23 19 23H8C6.89543 23 6 22.1046 6 21V11C6 9.89543 6.89543 9 8 9H19Z"
      fill="currentColor"
    />
  </svg>
);
export default StreamSvgIcon;
